export default "/images/3f8a3334047c52b59dce0e447421ceb1.avif";